import {
	ACCEPTED_TERMS,
	LOGIN_SSO_FACEBOOK_ERROR,
	LOGIN_SSO_FACEBOOK_REQUEST,
	LOGIN_SSO_FACEBOOK_SUCCESS,
	LOGIN_SSO_GOOGLE_ERROR,
	LOGIN_SSO_GOOGLE_REQUEST,
	LOGIN_SSO_GOOGLE_SUCCESS,
	LOGIN_SUCCESS,
	LOGOUT,
	REFRESH_TOKEN,
	REJECTED_TERMS
} from '../types/types';

const initialState = {
	user: null,
	loading: false,
	isAuthenticated: false,
	ACCESS_TOKEN: null,
	accessTokenExpirationDate: null,
	REFRESH_TOKEN: null,
	error: null,
	firstTimeUser: true,
	datefirstTimeUserLogin: null,
	acceptedTerms: false
};

export default function authReducer(state = initialState, action: any = {}) {
	switch (action.type) {
		case LOGIN_SUCCESS:
			return {
				...state,
				user: action.payload,
				ACCESS_TOKEN: action.payload.accessToken,
				accessTokenExpirationDate: action.payload.accessTokenExpirationDate,
				REFRESH_TOKEN: action.payload.refreshToken.refreshToken,
				refreshTokenExpirationDate: action.payload.refreshToken.expirationDate,
				acceptedTerms: action.payload.acceptedTerms,
				isAuthenticated: true,
				loading: false,
				error: null,
				firstTimeUser: false,
				datefirstTimeUserLogin: new Date()
			};
		case REFRESH_TOKEN:
			return {
				...state,
				ACCESS_TOKEN: action.payload.accessToken,
				accessTokenExpirationDate: action.payload.accessTokenExpirationDate,
				REFRESH_TOKEN: action.payload.refreshToken.refreshToken,
				refreshTokenExpirationDate: action.payload.refreshToken.expirationDate
			};
		case LOGOUT:
			return {
				user: null,
				loading: false,
				isLoggedIn: false,
				ACCESS_TOKEN: null,
				accessTokenExpirationDate: null,
				REFRESH_TOKEN: null,
				error: null
			};

		case LOGIN_SSO_GOOGLE_REQUEST:
			return {
				...state,
				user: action.user,
				loadingGoogleSSO: true,
				errorGoogleSSO: null
			};
		case LOGIN_SSO_FACEBOOK_REQUEST:
			return {
				...state,
				user: action.user,
				loadingFacebookSSO: true,
				errorFacebookSSO: null
			};
		case LOGIN_SSO_GOOGLE_ERROR:
			return {
				...state,
				loadingGoogleSSO: false,
				errorGoogleSSO: action.error
			};
		case LOGIN_SSO_FACEBOOK_ERROR:
			return {
				...state,
				loadingFacebookSSO: false,
				errorFacebookSSO: action.error
			};
		case LOGIN_SSO_GOOGLE_SUCCESS:
			return {
				...state,
				user: action.payload,
				oldUser: action.payload,
				ACCESS_TOKEN: action.payload.accessToken,
				accessTokenExpirationDate: action.payload.accessTokenExpirationDate,
				REFRESH_TOKEN: action.payload.refreshToken,

				loadingGoogleSSO: false,
				errorGoogleSSO: null,
				firstTimeUser: false,
				datefirstTimeUserLogin: new Date()
			};
		case LOGIN_SSO_FACEBOOK_SUCCESS:
			return {
				...state,
				user: action.payload,
				oldUser: action.payload,
				ACCESS_TOKEN: action.payload.accessToken,
				accessTokenExpirationDate: action.payload.accessTokenExpirationDate,
				REFRESH_TOKEN: action.payload.refreshToken,

				loadingFacebookSSO: false,
				errorFacebookSSO: null,
				firstTimeUser: false,
				datefirstTimeUserLogin: new Date()
			};
		case ACCEPTED_TERMS:
			return {
				...state,
				acceptedTerms: true
			};
		case REJECTED_TERMS:
			return {
				...state,
				acceptedTerms: false
			};
		default:
			return state;
	}
}
